import React from 'react';
import { Countdown } from '../Countdown';
import { CtaButton } from '../CtaButton';
import { PRECIO_TACHADO, PRECIO_VENTA } from '../../utils/constants';
export function FinalCta() {
  return <section className="bg-violeta-profundo text-crema py-20 px-5" data-id="element-108" data-mp="1nphroih65wm0">
      <div className="max-w-3xl mx-auto text-center" data-id="element-109" data-mp="1nn5cgd2sq0cn">
        <h2 className="font-serif text-3xl sm:text-4xl font-bold leading-tight" data-id="element-110" data-mp="1sn18nq594nhn">
          Quince minutos por día, veintiún días, y la letra deja de ser un problema
        </h2>
        <p className="mt-4 text-lg text-crema/80" data-id="element-111" data-mp="1iqent1cxdwfm">
          6 tomos + 6 bonos a <span className="line-through opacity-60" data-id="element-112" data-mp="14q3ttpgbk1q8">{PRECIO_TACHADO}</span>{' '}
          <span className="text-coral font-bold" data-id="element-113" data-mp="14s8891bugj4r">{PRECIO_VENTA}</span>
        </p>
        <Countdown className="mt-8" tone="dark" data-id="element-114" data-mp="19pqicv1ll4ec" />
        <CtaButton action="checkout" size="xl" pulse className="mt-8 w-full sm:w-auto" data-id="element-115" data-mp="2z4ekm3gh55yn">
          LO QUIERO AHORA
        </CtaButton>
        <p className="mt-4 text-sm text-crema/65" data-id="element-116" data-mp="3426irf7ppoba">
          Pago único · Acceso al instante · Garantía de 14 días
        </p>
      </div>
    </section>;
}